export const SEARCH_FORM_SUBMIT = 'STAFF.ONLINE_SURVEYS.TOKENS.SEARCH_FORM_SUBMIT';
export const SORT_CHANGE = 'STAFF.ONLINE_SURVEYS.TOKENS.SORT_CHANGE';
export const PAGE_CHANGE = 'STAFF.ONLINE_SURVEYS.TOKENS.PAGE_CHANGE';
export const FETCH_LIST = 'STAFF.ONLINE_SURVEYS.TOKENS.FETCH_LIST';
